module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modelSubmissions"
  }, [_c('div', {
    staticClass: "flex justify-center items-center"
  }, [_c('p', {
    staticClass: "b f3"
  }, [_vm._v("Model Submissions")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "margin-right": "-36px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_info = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._l((_vm.model_submissions), function(submission) {
    return _c('div', [(
      !submission.is_hidden ||
      (submission.is_hidden && _vm.hasTeacherPermissionsInCourse) ||
      _vm.ownSubmission(submission.id)
    ) ? _c('submission-card', {
      key: submission.id,
      staticClass: "model-submission-card center tl",
      attrs: {
        "submission": submission,
        "isInSummary": true
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), (
    !_vm.model_submissions.length ||
    (!_vm.hasTeacherPermissionsInCourse &&
      _vm.model_submissions.length &&
      _vm.isLastHidden)
  ) ? _c('div', {
    staticClass: "flex justify-center items-center"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.show_info) ? _c('pl-dialog', {
    staticClass: "pl-subheading italics",
    on: {
      "close": function($event) {
        _vm.show_info = false
      }
    }
  }, [_c('p', [_vm._v("\n        Teachers use the submission \"star\" to identify model submissions from\n        the RoundTable discussion.\n      ")]), _vm._v(" "), _c('p', [_vm._v("All model submissions will appear here in the RoundTable summary.")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.show_info = false
      }
    }
  }, [_vm._v("\n        OK\n      ")])], 1) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-50 br2"
  }, [_c('div', {
    staticClass: "flex items-center justify-between mb3"
  }, [_c('div', {
    staticClass: "bg-light-gray h2 br2 mv1 w-80 mr2"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa-2x fa fa-star light-gray",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bg-light-gray h1 br2 mv2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-light-gray h1 br2 mv2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-light-gray h1 br2 mv2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grow ml4 tl pl-subheading gray"
  }, [_c('p', [_vm._v("\n          Teachers use the submission \"star\" to identify model submissions\n          from the RoundTable discussion.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          All model submissions will appear here in the RoundTable summary.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-41e3c5b7!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/roundtableSummary/roundtableSummaryModelSubmissions.vue
// module id = 1214
// module chunks = 61